/* ATLAS · VF RUNTIME – VF UTILS */
/* ============================================================
   GLOBAL CONFIG & PARAMS
   - parametri letti dalla querystring
   - configurazione sessione Voiceflow
   - endpoint + token Apps Script
   ============================================================ */
  console.log('[ATLAS] utils LOADED');

  // Runtime endpoint (Voiceflow core – extremely unlikely to change)
  const VOICEFLOW_RUNTIME_URL = 'https://general-runtime.voiceflow.com';

  // =============================
  // ⚙️ Configurazione Voiceflow
  // =============================
  const VOICEFLOW_PROJECT_ID = '6a3f8ac295a144a8ab20ce66';

  // Endpoint Apps Script backend_menu (modifica qui se cambi URL)
  const BASE_APPSCRIPT_URL =
    "https://script.google.com/macros/s/AKfycbzPsg4nN3MWyXyGLPXnPTJSEZvFVak4t87bTHw7ltM5j3z5DrvPITsEiedZvDp0-5wWQA/exec"; // + Token & Endpoint backend_menu ------------------------------------
  
  // Token per validare la chiamata all'endpoint Atlas_menu
  const ATLAS_TOKEN = "GVP_IT_ML";

  // --- Parametri URL -------------------------------------------------------
  const params = new URLSearchParams(window.location.search);

  // Parametro K (categoria / ristorante) con fallback a T1
  const kParam = params.get('k') || params.get('K') || "T1";

  // Debug HUD attivabile con ?debug=1
  const DEBUG_MODE = params.get('debug') === '1';

  // --- Cache & Storage Keys ------------------------------------------------
  // Variabili di stato per sessione locale
  const SESSION_KEY      = "__VF_SESSION_STATE";  // stato generico
  const VF_SESSION_KEY   = "__VF_USER";           // user persistente VF
  const VF_GUEST_KEY     = "__VF_GUEST";          // utente guest VF

  // --- Retry Engine --------------------------------------------------------
  // Numero massimo tentativi (per operazioni di rete)
  const RETRY_MAX = 5;

  // Ritardo base retry (usato dal meccanismo di backoff)
  const RETRY_BASE_DELAY = 3000;

// ============================================================
// GLOBAL FLAGS (SAFE SHARED)
// ============================================================
window.__ATLAS_FLAGS__ = window.__ATLAS_FLAGS__ || {
  vfStarted: false,
  bundleLoaded: false,
  widgetLoading: false
};

// ============================================================
// ATLAS NAMESPACES (NO-OP, safe)
// ============================================================
  window.ATLAS = window.ATLAS || {
    core: {},
    session: {},
    data: {},
    ui: {},
    net: {},
    vf: {}
  };

  ATLAS.utils = ATLAS.utils || {};

  /* ============================
       FUNZIONE UTILI: lettura parametri URL
     - getParamUrl(param): ritorna valore o null
     - usiamo questa funzione per leggere mesa e K
  ============================= */
  ATLAS.utils.getParamUrl = function (param) {
  const paramsLocal = new URLSearchParams(window.location.search);
  return paramsLocal.get(param) || null;
};

  // Leggiamo qui mesa e keyK (K)
  const mesaFromUrl = ATLAS.utils.getParamUrl('mesa');
  const keyKFromUrl = ATLAS.utils.getParamUrl('K'); // preferibile 'K' maiuscolo QR, ma getParamUrl è case-sensitive
  // Fallback sulla kParam se 'K' non è presente
  const runtimeK = keyKFromUrl || kParam;

  // Log di base (solo per debug)
  debugInitialLog();

  function debugInitialLog(){
    try {
      if (DEBUG_MODE) {
        console.log(`[ATLAS] Mesa (raw): ${mesaFromUrl}`);
        console.log(`[ATLAS] Key K (raw): ${keyKFromUrl}  → runtimeK: ${runtimeK}`);
      }
    } catch(e){}
  }
  
  /* ============================
       CACHE HELPERS (sessionStorage)
  ============================= */
  ATLAS.utils.cache = {
  read(key) {
    try {
      const v = sessionStorage.getItem(key);
      return v ? JSON.parse(v) : null;
    } catch {
      return null;
    }
  },
  write(key, val) {
    try {
      sessionStorage.setItem(key, JSON.stringify(val));
    } catch {}
  },
  remove(key) {
    try {
      sessionStorage.removeItem(key);
    } catch {}
  }
};

/* ============================
       DEBUG OVERLAY (HUD)
     - mostra informazioni se ?debug=1
  ============================= */
ATLAS.utils.debugLog = function (...args) {
  if (!DEBUG_MODE) return;
  try {
    let el = document.getElementById('vf-debug');
    if (!el) {
      el = document.createElement('div');
      el.id = 'vf-debug';
      document.body.appendChild(el);
    }
    const ts = new Date().toISOString().slice(11,23);
    el.textContent =
      ts +
      ' ' +
      args.map(a =>
        typeof a === 'object' ? JSON.stringify(a) : String(a)
      ).join(' | ');
  } catch {}
};

// === SAFE LOGGER UNIVERSALE ===
window.note = window.note || function(label, data = {}) {
  try {
    const prefix = "[VF-ENT]";
    if (window.__VF_ENTERPRISE_DEBUG__ || location.search.includes("debug=1")) {
      console.log(`${prefix} [note] ${label}`, data);
    }
  } catch(e) { /* silenzioso */ }
};

ATLAS.core.delay = function (ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
};

// ============================================================
// EXPORT CONFIG → ATLAS.core
// ============================================================
ATLAS.core.config = {
  VOICEFLOW_RUNTIME_URL,
  VOICEFLOW_PROJECT_ID,
  BASE_APPSCRIPT_URL,
  ATLAS_TOKEN,
  DEBUG_MODE,
  RETRY_MAX,
  RETRY_BASE_DELAY
};

ATLAS.core.runtime = {
  params,
  mesaFromUrl,
  runtimeK,
  kParam,
  keyKFromUrl
};

ATLAS.core.storage = {
  SESSION_KEY,
  VF_SESSION_KEY,
  VF_GUEST_KEY
};

// ATLAS.core.delay = delay;
window.__ATLAS_DEBUG__ = DEBUG_MODE;

// ============================================================
// ATLAS CORE READY FLAG
// ============================================================
window.__ATLAS_CORE_READY__ = true;

console.log('[ATLAS] utils END');
window.__ATLAS_CORE_READY__ = true;
